import React from 'react'
import { createRoot } from 'react-dom/client'
import CartExpiration from 'src/shared/components/cart-expiration'
import OrderHistoryApp from 'src/order-history/index.jsx'
import App from 'src/order-history/views/app'
import SidebarContent from 'src/group-purchases/components/SidebarContent.jsx'
import GroupPurchasesApp from 'src/group-purchases/index.jsx'
import GppSharedTimer from 'src/shared/components/gpp-shared-timer'
import GppSharedSummary from 'src/shared/components/gpp-shared-summary'
import OrderSummary from 'src/carts/components/order-summary'
import TicketOptionsContainer from 'src/shared/components/ticket-options-container'

// Map of component names to their React components
const COMPONENTS = {
  CartExpiration,
  OrderHistoryApp,
  App,
  SidebarContent,
  GroupPurchasesApp,
  GppSharedTimer,
  GppSharedSummary,
  OrderSummary,
  TicketOptionsContainer
}

// Mount components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Find all component containers
  Object.keys(COMPONENTS).forEach(componentName => {
    const containerId = `${componentName.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()}-component`
    const container = document.getElementById(containerId)

    if (container) {
      const props = JSON.parse(container.dataset.props)
      const Component = COMPONENTS[componentName]
      const root = createRoot(container)
      root.render(<Component {...props} />)
    }
  })
})
